/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Attr_Member_PlaceholderInputs */



/**
* | output |
* | --- |
* | "VEKN ID or name of the member who designed it" |
*
* @param {Deck_Upload_Attr_Member_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_attr_member_placeholder = /** @type {((inputs?: Deck_Upload_Attr_Member_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Attr_Member_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("VEKN ID ou nom du membre qui l'a conçu")
	if (locale === "es") return /** @type {LocalizedString} */ ("VEKN ID o nombre del miembro que lo diseñó")
	if (locale === "pt") return /** @type {LocalizedString} */ ("VEKN ID ou nome do membro que o criou")
	if (locale === "it") return /** @type {LocalizedString} */ ("VEKN ID o nome del membro che l'ha creato")
	return /** @type {LocalizedString} */ ("VEKN ID or name of the member who designed it")
});